// 西班牙语
import esLocale from 'element-ui/lib/locale/lang/es'


const es = {
  // ============= 登录 start ============
  "验证码": "Código de verificación",
  "登录": "Iniciar sesión",
  "请输入验证码": "Por favor, introduzca el código de verificación",
  "验证码不正确!": "¡Código de verificación incorrecto!",
  "请输入账号": "Por favor, introduzca su cuenta",
  "请输入密码": "Por favor, introduzca su contraseña",
  "访问地址有误，请在shop后台核实": "La dirección de acceso es incorrecta, por favor verifique en el backend de la tienda",
  // ============= 登录 end ============

  // ============= Layout start ============
  "全屏模式": "Modo de pantalla completa",
  "首页": "Inicio",
  "此操作将退出登录, 是否继续?": "Esta operación cerrará sesión, ¿desea continuar?",
  "已取消退出": "Cierre de sesión cancelado",
  "您有一个新订单": "Tiene un nuevo pedido",
  "无法获取当前门店信息，请重新登录": "No se puede obtener la información actual de la tienda, por favor inicie sesión de nuevo",
  "收银台": "Caja",
  "收银": "Cobrar",
  "桌台": "Mesa",
  "订单": "Orden",
  // ============= Layout end ============

  // ============= 首页 start ============
  "查询会员": "Buscar miembro",
  "商品改价": "Cambiar precio",
  "商品删行": "Eliminar artículo",
  "整单取消": "Cancelar orden",
  "挂单": "Mantener orden",
  "折扣": "Descuento",
  "抹零": "Redondear",
  "请输入内容": "Por favor, ingrese contenido",
  "收银员": "Cajero",
  "店内就餐": "Consumo en local",
  "打包带走": "Para llevar",
  "商品名称": "Nombre del artículo",
  "商品价格": "Precio del artículo",
  "商品数量": "Cantidad del artículo",
  "应收": "Total a pagar",
  "包装费": "Tarifa de empaquetado",
  "优惠": "Descuento",
  "数量": "Cantidad",
  "件": "Pieza",
  "实收": "Monto recibido",
  "收款": "Recibir pago",
  "请选择商品": "Por favor, seleccione artículos",
  "确定要删除": "¿Está seguro de que desea eliminar",
  "提示": "Consejo",
  "确定": "Confirmar",
  "取消": "Cancelar",
  "请先将购物车内的商品挂单或结账后再取单": "Por favor, guarde o pague por los artículos en el carrito antes de recoger la orden",
  "确定要整单取消吗?": "¿Está seguro de que desea cancelar la orden?",
  "请输入会员手机号查询会员，输入完毕后点击确认": "Por favor, ingrese el número de teléfono del miembro para buscarlo, luego haga clic en confirmar",
  "请输入会员手机号": "Por favor, ingrese el número de teléfono del miembro",
  "会员昵称": "Alias del miembro",
  "余额总计": "Saldo total",
  "退出": "Salir",
  "该用户不存在": "Este usuario no existe",
  "折扣抹零": "Descuento/Redondear",
  "当前价格": "Precio actual",
  "改价": "Cambiar precio",
  "实付价格": "Precio real",
  "请输入实付价格": "Por favor, ingrese el precio real",
  "优惠折扣": "Tasa de descuento",
  "请输入优惠折扣": "Por favor, ingrese la tasa de descuento",
  "抹分": "Redondear al décimo más cercano",
  "抹角": "Redondear al dólar más cercano",
  "四舍五入到角": "Redondear al décimo más cercano",
  "四舍五入到元": "Redondear al dólar más cercano",
  "确 定": "Confirmar",
  "价格不能为空": "El precio no puede estar vacío",
  "折扣不能为空": "El descuento no puede estar vacío",
  "修改价格": "Modificar precio",
  "本次售价": "Precio de venta actual",
  "请输入本次售价": "Por favor, ingrese el precio de venta actual",
  "清空": "Limpiar",
  "确认": "Confirmar",
  "商品详情": "Detalles del artículo",
  "单位": "Unidad",
  "规格": "Especificaciones",
  "加料": "Ingredientes adicionales",
  "取 消": "Cancelar",
  "现金收款": "Pago en efectivo",
  "余额收款": "Pago con saldo",
  "其他方式": "Otras formas",
  "应收金额": "Monto total debido",
  "用户通过店内扫码等方式进行支付，确认用户支付成功后，点击确认付款即可完成付款操作。": "Los clientes pueden pagar mediante código QR y otros métodos en la tienda. Después de confirmar el pago exitoso, haga clic en 'Confirmar Pago' para completar la transacción.",
  "微信支付": "Pago con WeChat",
  "支付宝支付": "Pago con Alipay",
  "pos刷卡": "Pago con tarjeta POS",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Por favor, ingrese la ID de miembro para buscar el miembro, luego haga clic en confirmar",
  "请输入会员ID": "Por favor, ingrese la ID de miembro",
  "登录会员仅作为积分累计，无法享受其他优惠。": "Los miembros registrados solo pueden acumular puntos y no son elegibles para otros descuentos.",
  "取消收款": "Cancelar pago",
  "订单总价": "Precio total del pedido",
  "挂单时间": "Tiempo de retención de la orden",
  "删除": "Eliminar",
  "取单": "Recoger orden",
  "多语言小票打印": "Impresión de recibos multilingüe",
  "打印语言": "Idioma de impresión",
  "中文": "Chino",
  "英语": "Inglés",
  "德语": "Alemán",
  "法语": "Francés",
  "西班牙语": "Español",
  "意大利语": "Italiano",
  "克罗地亚": "Croata",
  "斯洛文尼亚": "Esloveno",
  "匈牙利语": "Húngaro",
  "塞尔维亚语": "Serbio",
  // ============= 首页 end ============

  // ============= 桌台 start ============
  "未开台": "No Abierto",
  "已开台": "Mesa Abierta",
  "就餐中": "Cenando",
  "刷新": "Actualizar",
  "整单清空": "Borrar Pedido Completo",
  "转台": "Cambiar de Mesa",
  "打印预结单": "Imprimir Factura Preliminar",
  "催菜": "Agilizar Pedido",
  "人数": "Número de Clientes",
  "订单来源": "Origen de la Orden",
  "请点击左侧桌号台": "Por favor, haga clic en el número de mesa a la izquierda",
  "点选已开台桌台，可以在此查看点餐信息。": "Seleccione una mesa abierta para ver los detalles de la orden aquí.",
  "服务费": "Cargo de Servicio",
  "税费": "Impuestos",
  "协助点餐": "Ayuda en la Orden",
  "协助加餐": "Ayuda en Agregar Artículos",
  "结账": "Pagar",
  "完成": "Completar",
  "价格": "Precio",
  "请选择": "Por favor seleccione",
  "确定要打印小票吗?": "¿Está seguro de que desea imprimir el recibo?",
  "确定要关闭桌台并取消订单吗?": "¿Está seguro de que desea cerrar la mesa y cancelar la orden?",
  "请选择桌号": "Por favor selecciona un número de mesa",
  "就餐人数": "Número de Comensales",
  "下单": "Hacer Pedido",
  "返回": "Regresar",
  "确定要商品删行吗?": "¿Está seguro de que desea eliminar la fila del artículo?",
  "请选择就餐人数": "Por favor selecciona el número de comensales",
  // ============= 桌台 end ============

  // ============= 订单 start ============
  "下单时间": "Hora del Pedido",
  "起始时间": "Hora de Inicio",
  "店内订单": "Orden en Local",
  "自提订单": "Orden de Recogida",
  "外卖订单": "Orden de Entrega",
  "名称": "Nombre",
  "支付时间": "Hora de Pago",
  "消费方式": "Método de Pago",
  "状态": "Estado",
  "单价": "Precio Unitario",
  "金额": "Cantidad",
  "税率": "Tasa de Impuestos",
  "税费金额": "Monto de Impuestos",
  "邮箱地址": "Dirección de Correo Electrónico",
  "今天": "Hoy",
  "昨天": "Ayer",
  "一周": "Una Semana",
  "搜索": "Buscar",
  "待完成": "Pendiente",
  "已完成": "Completado",
  "已取消": "Cancelado",
  "全部": "Todo",
  "顾客信息": "Información del Cliente",
  "用户昵称": "Seudónimo de Usuario",
  "手机号": "Número de Teléfono",
  "收货地址": "Dirección de Entrega",
  "取单号": "Número de Recogida de Orden",
  "就餐方式": "Método de Comida",
  "订单号": "Número de Orden",
  "订单金额": "Monto de la Orden",
  "订单优惠": "Descuento de la Orden",
  "实付金额": "Monto Pagado Real",
  "支付方式": "Método de Pago",
  "备注信息": "Observaciones",
  "期望配送时间": "Tiempo de Entrega Esperado",
  "取餐时间": "Hora de Recogida",
  "配送费": "Tarifa de Entrega",
  "退款金额": "Monto de Reembolso",
  "准备中": "Preparando",
  "出餐中": "Cocinando",
  "待取餐": "Esperando por la Recogida",
  "订单信息": "Información de la Orden",
  "税费详情": "Detalles de Impuestos",
  "取消订单": "Cancelar Orden",
  "打印小票": "Imprimir Recibo",
  "出餐": "Servir Platos",
  "确认送达": "Confirmar Entrega",
  "退款": "Reembolso",
  "已退款": "Reembolsado",
  "请输入订单号": "Por favor, introduce el número de orden",
  "至": "A",
  "开始日期": "Fecha de Inicio",
  "结束日期": "Fecha de Fin",
  "发送账单": "Enviar Factura",
  "请输入邮箱地址": "Por favor, introduce tu dirección de correo electrónico",
  "确定要催菜吗?": "¿Está seguro de que desea agilizar el pedido?",
  "确定要完成订单吗?": "¿Está seguro de que desea completar la orden?",
  "确定要出餐吗?": "¿Está seguro de que desea servir los platos?",
  "确定要发送账单吗?": "¿Está seguro de que desea enviar la factura?",
  "邮箱不能为空": "El correo electrónico no puede estar vacío",
  "确定要取消订单吗?": "¿Está seguro de que desea cancelar la orden?",
  "是否确认此操作?": "¿Está seguro de que desea confirmar esta operación?",
  "上传文件只能是excel格式!": "¡El archivo cargado debe ser en formato Excel!",
  "上传文件大小不能超过 10MB!": "¡El tamaño del archivo cargado no puede superar los 10 MB!",
  "正在处理,请等待": "Procesando, por favor espera",
  "本次处理失败": "Falló el proceso esta vez",
  "总金额": "Monto Total",
  "可退款金额": "Monto Reembolsable",
  "请输入退款金额": "Por favor, introduce el monto de reembolso",
  "超出可退款金额": "Supera el monto reembolsable",
  "404错误页面": "Página de Error 404",
  "合计": "Total",
  "份": "Porción",
  "余额支付": "Pago de Saldo",
  "线下支付(现金支付)": "Pago Offline (Pago en Efectivo)",
  "线下支付(微信支付)": "Pago Offline (Pago con WeChat Propio)",
  "线下支付(支付宝支付)": "Pago Offline (Pago con Alipay Propio)",
  "线下支付(POS刷卡支付)": "Pago Offline (Pago con Tarjeta POS)",
  "进行中": "En Progreso",
  "待付款": "Pago Pendiente",
  "待配送": "Pendiente de Envío",
  "配送中": "En Reparto",
  "待接单": "Esperando Aceptación",
  "待取货": "Pendiente de Recogida",
  "已配送": "Ya Entregado",
  "已收货": "Mercancía Recibida",
  "待收货": "Por Recibir",
  "待取消": "Por Cancelar",
  "会员": "Miembro",
  "商家": "Comerciante",
  "供应商": "Proveedor",
  "分销": "Distribución",
  "通知": "Notificación",
  "已付款": "Ya Pagado",
  "用户下单": "Pedido de Usuario",
  "收银台下单": "Pedido en Caja",
  "扫码下单": "Pedido por Escaneo",
  "团购下单": "Pedido de Compra en Grupo",
  "商城订单": "Pedido de Centro Comercial",
  "积分商城订单": "Pedido de Centro Comercial con Puntos",
  "余额充值订单": "Pedido de Recarga de Saldo",
  "购卡订单": "Pedido de Compra de Tarjeta",
  "券包订单": "Pedido de Paquete de Cupones",
  "配送员押金订单": "Pedido de Depósito para Repartidores",
  "团购订单": "Pedido de Compra en Grupo",
  "下单减库存": "Reducción de Inventario con Pedido",
  "付款减库存": "Reducción de Inventario con Pago",
  "商家配送": "Entrega por el Comerciante",
  "外卖配送": "Entrega a Domicilio",
  "到店自提": "Recogida en Tienda",
  "快递配送": "Envío por Mensajería",
  "个人中心": "Centro Personal",
  ...esLocale
}



export default es



// WEBPACK FOOTER //
// ./src/i18n/langs/es.js